// extracted by mini-css-extract-plugin
export default {"colorTangelo":"#fc4c02","banners":"MainBanner_banners__UU2Td","banner":"MainBanner_banner__qXwQv","banner__wrapper":"MainBanner_banner__wrapper__mMYlu"};